import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
//search module
import { Ng2SearchPipeModule } from 'ng2-search-filter';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { AuthService } from './auth.service';
import { AccountStatsService } from './account-stats.service';
import { MsalModule, MsalInterceptor, MsalGuard } from '@azure/msal-angular';

import { environment } from '../environments/environment';
import { MidStageAccountRanksComponent } from './mid-stage-account-ranks/mid-stage-account-ranks.component';
import { UserManagerComponent } from './user-manager/user-manager.component';
import { AlertComponent } from './alert/alert.component';
import { AlertService } from './alert.service';
import { CatComponent } from './cat/cat.component';
import { deactivatedNumbersComponent } from './deactivated-numbers/deactivated-numbers.component';
import { agentDNCEntriesComponent} from './agent-dnc-entries/agent-dnc-entries.component'
import { textRepliesComponent } from './text-replies/text-replies.component';
import { NewUsersComponent } from './user-manager/new-users/new-users.component';
import { EmailRepliesComponent } from './email-replies/email-replies.component';
import { ReferenceAutomationExceptionsComponent } from './reference-automation-exceptions/reference-automation-exceptions.component';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    MidStageAccountRanksComponent,
    UserManagerComponent,
    deactivatedNumbersComponent,
    agentDNCEntriesComponent,
    AlertComponent,
    CatComponent,
    textRepliesComponent,
    NewUsersComponent,
    EmailRepliesComponent,
    ReferenceAutomationExceptionsComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    Ng2SearchPipeModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'midstage-accounts', component: MidStageAccountRanksComponent },
      { path: 'user-manager', component: UserManagerComponent },
      { path: 'deactivated-numbers', component: deactivatedNumbersComponent },
      { path: 'agent-dnc-entries', component: agentDNCEntriesComponent },
      { path: 'text-replies', component: textRepliesComponent },
      { path: 'new-users', component: NewUsersComponent },
      { path: 'email-replies', component: EmailRepliesComponent },
      { path: 'reference-automation-exceptions', component: ReferenceAutomationExceptionsComponent }
    ]),
    MsalModule.forRoot({
      clientID: environment.MSAL.appId,
      authority: environment.MSAL.authority,
      popUp: true,
      redirectUri: environment.MSAL.redirect
  })

  ],
  providers: [ 
    AuthService,
    AlertService,
    AccountStatsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
  }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts